/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { lazy, Suspense } from 'react';

import { jsx } from '@compiled/react';
import { ErrorBoundary } from 'react-error-boundary';

import { IntlMessagesProvider } from '@atlaskit/intl-messages-provider';

import { fetchMessages } from '../common/utils/locale/fetch-messages';
import defaultMessages from '../i18n/en';
import { type ModalDialogContentProps } from '../types';

import { ErrorState } from './error-state';
import { LoadingState } from './loading-state';
import { withModalDialog } from './modal-dialog';

export const GlobalInvite = withModalDialog(AsyncGlobalInviteModalDialogContent);

export default AsyncGlobalInviteModalDialogContent; // This is only needed to support the Atlaskit docs. See https://hello.atlassian.net/wiki/spaces/navx/pages/5305993008/Platform+Guide#Atlaskit-%3CProps%3E-component-not-rendering

function AsyncGlobalInviteModalDialogContent(props: ModalDialogContentProps) {
	const modalContent = (
		<ErrorBoundary fallback={<ErrorState />}>
			<Suspense fallback={<LoadingState />}>
				<LazyGlobalInviteModalDialogContent {...props} />
			</Suspense>
		</ErrorBoundary>
	);

	return (
		<IntlMessagesProvider defaultMessages={defaultMessages} loaderFn={fetchMessages}>
			{modalContent}
		</IntlMessagesProvider>
	);
}

const LazyGlobalInviteModalDialogContent = lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_global-invite--modal-dialog-content" */
		'./modal-dialog-content'
	).then((module) => ({
		default: module.ModalDialogContent,
	})),
);
